import React, {Component} from 'react';
import styles from 'css/screens/registration.css';

/**
 * mark
 */
export default class Mark extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this.ssl = React.createRef();
  }

  /**
   * did mount
   */
  componentDidMount() {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('defer', 'defer');
    script.setAttribute(
      'src',
      '//seal.globalsign.com/SiteSeal/gmogs_image_115-57_ja.js'
    );

    this.ssl.current.appendChild(script);
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const globalsignImgSrc =
      '//seal.globalsign.com/SiteSeal/images/gs_noscript_115-57_ja.gif';

    return (
      <div className={styles.mark}>
        <a className={styles.pmark} target="_blank" href="https://privacymark.jp/" />
        <div className={styles.ssl} ref={this.ssl}>
          <span id="ss_gmo_img_wrapper_115-57_image_ja">
            <a href="https://jp.globalsign.com/" target="_blank" rel="nofollow">
              <img
                alt="SSL　GMOグローバルサインのサイトシール"
                border="0"
                id="ss_img"
                src={globalsignImgSrc}
              />
            </a>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/registration/mark.js